import type { HomeSlice } from '../bs/home'

/**
 * Serbian overrides for the home screens.
 *
 * The jat reflex throughout: *prijedlog* → *predlog*, *bezbjednost* →
 * *bezbednost*, *riješeno* → *rešeno*, *ocjena* → *ocena*, *mjesec* →
 * *mesec*, *zahtijeva* → *zahteva*, *dodijeljeno* → *dodeljeno*, *promjena*
 * → *promena*, *ovdje* → *ovde*, *prosjek* → *prosek*. And *nedelja* for the
 * week where Bosnian writes *sedmica*; *pojaviće* stays.
 */
export const home: Partial<HomeSlice> = {
  'home.report.text': 'Kvar, incident, bezbednost ili predlog za poboljšanje',

  'home.mine.resolved': 'Rešene',
  'home.recent.emptyText': 'Kada prijavite kvar ili pošaljete predlog, pojaviće se ovde sa statusom.',

  'home.rating.title': 'Moja ocena ovog meseca',
  'home.rating.empty': 'Ocena se pojavi nakon prvog obilaska ili zadatka u mesecu.',
  'home.rating.noTasks': 'Nema dodeljenih zadataka',
  'home.rating.proposals': 'Predlozi',

  'home.stat.overdue.needsAttention': 'Zahteva pažnju danas',
  'home.stat.overdue.explain':
    'Otvorene prijave kojima je rok prošao; prijave bez upisanog roka se ovde ne broje.',
  'home.stat.unassigned': 'Nedodeljene',
  'home.stat.myTasks.explain': 'Zadaci dodeljeni vama koji još nisu završeni.',

  'home.overdue.emptyText': 'Prijave kojima prođe rok pojaviće se ovde, najstarije prve.',
  'home.overdue.nobody': 'nije dodeljena',

  'home.fiveS.progress': 'Mašine obiđene ovog meseca',
  'home.fiveS.average': 'Prosek obilazaka ovog meseca: {value}',
  'home.fiveS.allWalked': 'Sve mašine su obiđene ovog meseca.',

  'home.activity.emptyText': 'Nove prijave, promene statusa i 5S obilasci pojaviće se ovde.',
  'home.activity.moved': 'Promena statusa {ref}',

  'home.tasks.soonCount.one': '{count} sa rokom ove nedelje',
  'home.tasks.soonCount.few': '{count} sa rokom ove nedelje',
  'home.tasks.soonCount.many': '{count} sa rokom ove nedelje',
  'home.tasks.nothingSoon': 'Ništa hitno ove nedelje',
  'home.tasks.emptyText': 'Zadaci koje vam neko dodeli uz prijavu pojaviće se ovde.',

  // *prosjek* -> *prosek*.
  'home.fiveS.plant': 'Prosek pogona',
  // *nigdje* -> *nigde*, and *na kom* where Bosnian writes *na kojem*.
  'home.fiveS.explain':
    'Prosek pored stoji samo da imate s čim uporediti svoj broj — računa se iz pogona koje vidite, nije rang i nigde ne piše na kom ste mestu.',

  // *ocjena* -> *ocena*, *prijedlog* -> *predlog*, *mjesto* -> *mesto*,
  // *završeni* is shared.
  'leaderboard.formula':
    'Osnova: 5S {fiveS} i završeni zadaci {tasks}. Prihvaćeni predlozi dodaju do +{bonus} bodova ({accepted} prihvaćena predloga za punu premiju) — predlozi mogu samo da podignu ocenu, nikada je ne smanjuju.',
  // *dio* -> *deo*, *dijeli* -> *deli*, *sljedeći* -> *sledeći*.
  'leaderboard.explain.note':
    'Deo za 5S govori o mašinama koje je neko održavao, a ne o njemu — ko je prešao na zapušten centar ima nizak procenat upravo zbog toga. Prihvaćeni predlozi se dodaju na osnovu i mogu je samo podići: odbijen predlog ne oduzima ništa. Ko nije bio ni na jednom obilasku ili nema nijedan zadatak, ocenjuje se samo po onome što ima, a deo koji nedostaje se ne računa kao nula.',
  'leaderboard.explain.ties':
    'Isti rezultat deli isto mesto: dvoje sa 82 su oboje drugi, a sledeći je četvrti.',
  'leaderboard.rating': 'Ocena',
  'leaderboard.position': 'Mesto',

  'home.fiveS.plant.several': 'Prosek vaših pogona',
  'home.fiveS.plant.all': 'Prosek firme',
}
